<template>
  <div class="ai-float-button__wrapper" @mouseenter="isButtonVisible ? trackGAWhenHoverAIFLoatButton() : false">
    <div
      class="ai-float-button"
      v-tooltip="buttonTooltipContent"
      @click="handleOpenAIModal()"
    >
      <img :src="AIFloatButtonImage" alt="ai-button" class="w-full">
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AIFloatButtonImage from '@/assets/images/ai-generator/ai-button.svg'
import * as localStorageExpiry from '@/utils/local.storage.expiry'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    isButtonVisible: {
      type: Boolean,
      default: false,
    },
    isContentSlide: {
      type: Boolean,
      default: false,
    },
    gaTouchPoint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      AIFloatButtonImage,
      buttonTooltipContent: null,
      tooltipText: 'Let AI Slide Generator help you!',
      alreadySetButtonTooltipContent: false,
    }
  },
  computed: {
    ...mapState({
      indicators: (state) => state.indicators,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    keyShowTooltip() {
      return `has-shown-ai-float-button-tooltip-${this.$store.state.currentUser.id}`
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
  },
  watch: {
    isButtonVisible() {
      if (this.alreadySetButtonTooltipContent) return // no need to set tooltip in every watch
      this.buttonTooltipContent = null
      setTimeout(() => {
        this._setButtonTooltipContent()
      }, 200)
    },
    isPresentingOrBackstage() {
      this.buttonTooltipContent = null
    },
  },
  mounted() {
    if (this.isContentSlide) {
      this._setButtonTooltipContent()
      return
    }
    const hasAutoShownTooltip = localStorageExpiry.getWithExpiry(this.keyShowTooltip)
    if (!hasAutoShownTooltip) return
    if (this.buttonTooltipContent === this.tooltipText) {
      this.alreadySetButtonTooltipContent = true // no need to set tooltip in every watch
    }
  },
  methods: {
    ...mapActions(['setShowAISlideGeneratorModalAction']),
    handleOpenAIModal() {
      this.setShowAISlideGeneratorModalAction({
        show: true,
        touchPoint: this.gaTouchPoint,
      })
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'AI Quiz Generator > Open modal',
        null,
        null,
        {
          presentationId: this.presentation.id,
          touchPoint: this.gaTouchPoint,
        },
      )
    },
    _setButtonTooltipContent() {
      const hasAutoShownTooltip = localStorageExpiry.getWithExpiry(this.keyShowTooltip)
      const DAYS_30 = 30 * 24 * 60 * 60 * 1000
      if (hasAutoShownTooltip) {
        this.buttonTooltipContent = this.tooltipText
      } else {
        this.buttonTooltipContent = {
          content: this.tooltipText,
          show: this.isButtonVisible,
        }
        localStorageExpiry.setWithExpiry(this.keyShowTooltip, true, DAYS_30)
      }
    },
    trackGAWhenHoverAIFLoatButton() {
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'AI Quiz Generator > Hover',
        null,
        null,
        {
          presentationId: this.presentation.id,
          touchPoint: this.gaTouchPoint,
        },
      )
    },
  },
}
</script>

<style>
.ai-float-button__wrapper {
  @apply absolute -top-8 right-12 cursor-pointer z-1;
  .ai-float-button {
    @apply opacity-100 relative w-24;
    transition: opacity 0.2s ease-in;
  }
}
.ai-modal.aha-modal__body {
  min-width: 35rem;
  @apply px-0 py-0 mb-0 overflow-hidden;
  max-height: 90vh;
  .quiz-header {
    @apply p-0;
  }
  &::v-deep {
    .aha-textarea-wrapper .aha-textarea {
      height: calc(1.5em + 1rem);
    }
  }
}
</style>
